/**
 * @file header.component.tsx
 * @description Компонент заголовка каталога для Task Manager приложения, который обеспечивает область управления каталогом с названием, кнопкой закрытия, полем поиска через TableSearchInput, кнопкой фильтров через FilterButton и контекстным меню для дополнительных действий. Предоставляет полноценную панель инструментов для взаимодействия с содержимым каталога и навигации.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@components/ui/base/text', '@components/ui/base/button', '@consta/icons/IconClose', '@consta/icons/IconKebab', 'classnames', 'react', '@components/ui/custom/inputs/table-search-input', '@src/types', '@features/filter', '@consta/uikit/ContextMenu']
 * @related-files ['src/features/catalog/catalog.component.tsx', 'src/components/ui/custom/inputs/table-search-input', 'src/features/filter/components/table-toolbar/toolbar-button.tsx', 'src/types/context-object.ts']
 */

import { Text } from '@components/ui/base/text';
import { Button } from '@components/ui/base/button';
import { IconClose } from '@consta/icons/IconClose';
import { IconKebab } from '@consta/icons/IconKebab';
import cn from 'classnames';
import { EventHandler, MouseEvent, useRef, useState } from 'react';
import { TableSearchInput } from '@components/ui/custom/inputs/table-search-input';
import { TContextObject } from '@src/types';
import { ToolbarButton as FilterButton, filterComponent } from '@features/filter';
import { ContextMenu } from '@consta/uikit/ContextMenu';

interface IHeader {
    className?: string;
    title: string;
    searchText?: string;
    filterControls?: filterComponent[];
    isShowFilterModal?: boolean;
    isCanShowModal?: boolean;
    closePageHandler: EventHandler<MouseEvent>;
    contextMenuItems?: TContextObject[];
    onFilterButtonClick?: (isShow: boolean) => void;
}

export const Header = ({
    className,
    title = 'Заголовок',
    closePageHandler,
    filterControls,
    contextMenuItems = [],
    onFilterButtonClick,
    isShowFilterModal = false,
    isCanShowModal = false
}: IHeader) => {
    const [isShowContext, setIsShowContext] = useState<boolean>(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    return (
        <div className={cn('catalog__header w-full flex justify-between mb-[1.482vmin]', className)}>
            <Text size="xl" weight="semibold" className="leading-[2.5405vmin] text-primary">
                {title}
            </Text>

            <div className="catalog__header-controlPanel flex items-top gap-[0.8468vmin]">
                <TableSearchInput />

                {filterControls && (
                    <FilterButton
                        onFilterButtonClick={onFilterButtonClick}
                        filterControls={filterControls}
                        isShowFilterModal={isShowFilterModal}
                        isCanShowModal={isCanShowModal}
                    />
                )}

                <div className='flex items-top' ref={anchorRef}>
                    <Button
                        onlyIcon={true}
                        iconLeft={IconKebab}
                        onClick={() => setIsShowContext(!isShowContext)}
                        label="Дополнительно"
                        view="ghost"
                        iconSize="xs"
                        disabled={!contextMenuItems.length}
                    />
                </div>

                <Button
                    onlyIcon={true}
                    iconLeft={IconClose}
                    onClick={closePageHandler}
                    label="Закрыть"
                    view="clear"
                    className="ml-[2.1171vmin]"
                />

                <ContextMenu
                    items={contextMenuItems}
                    isOpen={isShowContext}
                    anchorRef={anchorRef}
                    getItemLeftSide={(item) => item.icon}
                    onItemClick={(item) => item.clickHandler && item.clickHandler()}
                    onClickOutside={() => setIsShowContext(false)}
                    direction="downStartRight"
                    style={{ pointerEvents: 'auto' }}
                    className="absolute"
                />
            </div>
        </div>
    );
};
